import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { format, parseISO, getHours } from "date-fns";
import ButtonStyle from "./buttonstyle";
import Form from "./form";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Radio from "./radio";
import Title from "./title";
import { Modal } from "../shared";

export default function OpenHouse({ mediaQuery, page, total }) {
  const submitUrl = "/api/applications/v4/application/open_house/";
  const {
    data: {
      open_houses,
      results: [
        {
          nomination_ind,
          submission: {
            membership_price,
            open_house: { id }
          }
        }
      ]
    }
  } = useQuery(["application"]);
  const is_partner = membership_price.membership_type_cd === "Partner";
  const nextUrl = is_partner ? "/apply/review/" : "/apply/invite-partner/";
  const [form, setForm] = useState({ id, errors: null });
  const [confirmed, setConfirmed] = useState(false);
  const day_choices = open_houses
    .filter((n) => getHours(parseISO(n.start_dttm)) < 16)
    .map((n) => ({
      id: n.id,
      name: format(parseISO(n.start_dttm), "PPPP"),
      description: format(parseISO(n.start_dttm), "p")
    }));
  const evening_choices = open_houses
    .filter((n) => getHours(parseISO(n.start_dttm)) >= 16)
    .map((n) => ({
      id: n.id,
      name: format(parseISO(n.start_dttm), "PPPP"),
      description: format(parseISO(n.start_dttm), "p")
    }));
  const choices = [
    {
      id: 0,
      name: "I will schedule later",
      description: ""
    }
  ];
  return (
    <Page>
      <PageHeader title={`APPLICATION PAGE ${page} OF ${total}`} tagline="Come introduce yourself.">
        <P style={{ marginBottom: "1rem" }}>
          Our open house event is the perfect opportunity for you to see and be seen. Join us at The
          Battery for a tour of our impeccably designed spaces, followed by a reception with
          Ambassadors and our membership team. We can’t wait to meet you!
        </P>
        {!nomination_ind && (
          <P>
            At this time you do not have an active nomination so we won&apos;t be able to invite you
            to an Open House. Kindly click &quot;I will schedule later&quot; below. We&apos;ll be
            reaching out to your references to learn more about you and if one of them nominates
            you, you&apos;ll get a message from us that you&apos;re now able to schedule an Open
            House. At that time you can return here and fully complete your application.
          </P>
        )}
      </PageHeader>
      {(day_choices.length > 1 || evening_choices > 1) && (
        <Title>Select one of the upcoming open house events</Title>
      )}
      <Form form={form} setForm={setForm} nextUrl={nextUrl} submitUrl={submitUrl}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center"
          }}
        >
          <div>
            {day_choices.length >= 1 && (
              <>
                <p style={{ fontFamily: "BentonModernDisplaySemiBold", fontSize: 30 }}>
                  Afternoon Open Houses
                </p>
                <p>Come meet us during the day over coffee and tea in a more relaxed atmosphere.</p>
                <Radio
                  name="id"
                  fullWidth={true}
                  form={form}
                  setForm={setForm}
                  vertical={true}
                  choices={day_choices}
                />
                <div style={{ marginBottom: "2rem" }}>&nbsp;</div>
              </>
            )}
            {evening_choices.length >= 1 && (
              <>
                <p style={{ fontFamily: "BentonModernDisplaySemiBold", fontSize: 30 }}>
                  Evening Open Houses
                </p>
                <p>Come meet us during the evening and see us hustle and bustle.</p>
                <Radio
                  name="id"
                  fullWidth={true}
                  form={form}
                  setForm={setForm}
                  vertical={true}
                  choices={evening_choices}
                />
              </>
            )}
            <Radio
              name="id"
              fullWidth={true}
              form={form}
              setForm={setForm}
              vertical={true}
              choices={choices}
            />
          </div>
        </div>
      </Form>
      {form?.id === 0 && !confirmed && (
        <Modal title="Open House Required">
          <p style={{ marginBottom: "2rem" }}>
            It&apos;s OK if you can&apos;t join us just now, but please be mindful that your
            application will not be considered until you attend an Open House.
          </p>
          <button style={ButtonStyle({ enabled: true })} onClick={() => setConfirmed(!confirmed)}>
            Confirm
          </button>
        </Modal>
      )}
    </Page>
  );
}
